import { NgModule } from "@angular/core";
import { ExecuteActionInstallationFunctionService } from "src/app/modules/bootstrap/functions/installations/execute-action-installation/execute-action-installation-function.service";
import { InstallationsFunctionsService } from "src/app/modules/bootstrap/functions/installations/installations-functions.service";
import { ConnectIntegrationFunctionModule } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration-function.module";

@NgModule({
  imports: [ConnectIntegrationFunctionModule],
  declarations: [],
  providers: [
    InstallationsFunctionsService,
    ExecuteActionInstallationFunctionService
  ]
})
export class ExecuteActionInstallationFunctionModule {}
